import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GetBeersDTO} from 'typescript/dto/beersDto';
import {GetBeerPubsFilters} from 'typescript/dto/GetBeerPubsDTO';
import {Beer} from 'typescript/models/Beer';
import PubPage from 'typescript/models/PubPage';

interface IState {
  beers: Beer[];
  totalPages: number;
  totalCount: number;
  included: {id: string; type: string; attributes: any}[];
  filters: GetBeersDTO;
  beerPubs: PubPage[];
  beerPubFilters: GetBeerPubsFilters;
  deleteBeerConfirmation: {id: string; name: string} | null;
  isLoading: boolean;
}

const initialState: IState = {
  isLoading: false,
  beers: [],
  totalPages: 1,
  totalCount: 0,
  included: [],
  filters: {page: 1, perPage: 14, direction: 'asc', name: '', column: 'name'},
  beerPubs: [],
  beerPubFilters: {page: 1, totalPages: 1, name: '', direction: 'asc', column: 'name'},
  deleteBeerConfirmation: null,
};

const beerSlice = createSlice({
  name: 'beers',
  initialState,
  reducers: {
    setBeersAC: (state, action: PayloadAction<IState['beers']>) => {
      state.beers = action.payload;
    },
    setBeersPageInfoAC: (state, action: PayloadAction<{totalPages: number; totalCount: number}>) => {
      state.totalPages = action.payload.totalPages;
      state.totalCount = action.payload.totalCount;
    },
    setBeersIncludedAC: (state, action: PayloadAction<IState['included']>) => {
      state.included = action.payload;
    },
    setCreatedBeerAC: (state, action: PayloadAction<Beer>) => {
      state.beers.push(action.payload);
    },
    setUpdatedBeerAC: (state, action: PayloadAction<Beer>) => {
      state.beers = state.beers.map((beer: Beer) => (beer.id === action.payload.id ? action.payload : beer));
    },
    setBeerFiltersAC: (state, action: PayloadAction<IState['filters']>) => {
      state.filters = action.payload;
    },
    setLoadingAC: (state, action: PayloadAction<IState['isLoading']>) => {
      state.isLoading = action.payload;
    },
    setBeerPubsAC: (state, action: PayloadAction<IState['beerPubs']>) => {
      state.beerPubs = action.payload;
    },
    setBeerPubFiltersAC: (state, action: PayloadAction<IState['beerPubFilters']>) => {
      state.beerPubFilters = action.payload;
    },
    setDeleteBeerConfirmationAC: (state, action: PayloadAction<IState['deleteBeerConfirmation']>) => {
      state.deleteBeerConfirmation = action.payload;
    },
  },
});

export default beerSlice;

export const {
  setBeerPubFiltersAC,
  setBeerFiltersAC,
  setBeerPubsAC,
  setBeersAC,
  setBeersPageInfoAC,
  setBeersIncludedAC,
  setCreatedBeerAC,
  setUpdatedBeerAC,
  setDeleteBeerConfirmationAC,
  setLoadingAC,
} = beerSlice.actions;
